import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./IntegrarWhatsApp.css";

const IntegrarWhatsApp = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [linkPagamento, setLinkPagamento] = useState(null);
  const [statusPagamento, setStatusPagamento] = useState(null);
  const [statusConexao, setStatusConexao] = useState(null);
  const navigate = useNavigate();

  const verificarStatus = async () => {
    try {
      const res = await fetch("/crm-wly/api/whatsapp/check_status.php", {
        credentials: "include",
      });
      const data = await res.json();

      const pagamento = data.status_pagamento;
      const conexao = data.status;

      setStatusPagamento(pagamento);
      setStatusConexao(conexao);

      // Regra 1 – Redireciona se pago e (ativo OU desconectado)
      if (pagamento === "pago" && (conexao === "ativo" || conexao === "desconectado")) {
        navigate("/wzp/painel-whatsapp");
        return;
      }

      // Regra 3 – Mostra link de pagamento se existir
      if (data.link_pagamento) {
        setLinkPagamento(data.link_pagamento);
      }

    } catch (err) {
      console.error("Erro ao verificar status de pagamento.");
    }
  };

  useEffect(() => {
    verificarStatus();
    const interval = setInterval(verificarStatus, 10000); // Regra 5
    return () => clearInterval(interval);
  }, []);

  const ativarWhatsApp = async () => {
  setLoading(true);
  setError(null);
  setLinkPagamento(null);

  try {
    const response = await fetch("/crm-wly/api/whatsapp/criar_cobranca_asaas.php", {
      method: "POST",
      credentials: "include",
    });

    const text = await response.text();
    console.log("Resposta bruta:", text); // DEBUG
    let data = {};
    try {
      data = JSON.parse(text);
    } catch (jsonError) {
      console.error("Erro ao parsear JSON:", jsonError);
      setError("Erro ao processar resposta do servidor.");
      return;
    }

    const pagamento = data.status_pagamento;
    const conexao = data.status;

    setStatusPagamento(pagamento);
    setStatusConexao(conexao);

    if (data.success) {
      if (pagamento === "pago" && (conexao === "ativo" || conexao === "desconectado")) {
        navigate("/wzp/painel-whatsapp");
      } else if (data.link_pagamento) {
        setLinkPagamento(data.link_pagamento);
      }
    } else {
      console.warn("Erro do backend:", data.message);
      setError(data.message || "Erro ao ativar integração.");
    }
  } catch (err) {
    console.error("Erro na conexão:", err);
    setError("Erro de conexão com o servidor.");
  } finally {
    setLoading(false);
  }
};


  // Regra 2 – Deve habilitar botão de ativação com base no status do pagamento
  const mostrarBotaoAtivacao = ["pendente", "vencido", "cancelado"].includes(statusPagamento);

  return (
    <div className="container-integrar-wzp">
      <h2>Integração com WhatsApp</h2>
      <p>Conecte seu WhatsApp com o sistema e centralize suas conversas com leads.</p>

      {mostrarBotaoAtivacao && (
        <button
          onClick={ativarWhatsApp}
          disabled={loading}
          style={{ padding: "10px 20px", fontSize: "16px", cursor: "pointer" }}
        >
          {loading ? "Verificando..." : "Ativar Integração"}
        </button>
      )}

      {error && <p className="erro-integracao">{error}</p>}

      {linkPagamento && (
        <div className="area-pagamento">
          <p><strong>Status do pagamento:</strong> {statusPagamento}</p>
          <a
            href={linkPagamento}
            target="_blank"
            rel="noopener noreferrer"
            className="botao-pagamento"
          >
            👉 Clique aqui para efetuar o pagamento de R$ 147,00
          </a>
          <p style={{ marginTop: 10, fontSize: 14 }}>
            Pagamento verificado automaticamente a cada 10 segundos.
          </p>
        </div>
      )}
    </div>
  );
};

export default IntegrarWhatsApp;
